export const PLANET_STONES = [
  { title: 'Sun', stone: 'Ruby', glyph: '☉' },
  { title: 'Moon', stone: 'Pearl', glyph: '☽' },
  { title: 'Mars', stone: 'Red Coral', glyph: '♂' },
  { title: 'Mercury', stone: 'Emerald', glyph: '☿' },
  { title: 'Jupiter', stone: 'Yellow Sapphire', glyph: '♃' },
  { title: 'Venus', stone: 'Diamond', glyph: '♀' },
  { title: 'Saturn', stone: 'Blue Sapphire', glyph: '♄' },
  { title: 'Rahu', stone: 'Hessonite', glyph: '☊' },
  { title: 'Ketu', stone: "Cat's Eye", glyph: '☋' },
]
